import { createAction } from 'typesafe-actions';
import type { FileUploadSource, FileUploadTarget } from './types';
import type { File as OfflineAssetFile } from 'store/assets/types';

export const addFileUpload = createAction('@FILE_UPLOAD/ADD')<{
  uploadId: string;
  file: FileUploadSource;
  filename: string;
  contentType: string;
  totalBytes: number;
}>();

export const setFileUploadTarget = createAction('@FILE_UPLOAD/TARGET_SET')<{
  uploadId: string;
  target: FileUploadTarget;
}>();

export const startFileUpload = createAction('@FILE_UPLOAD/STARTED')<{
  uploadId: string;
}>();

export const updateFileUploadProgress = createAction('@FILE_UPLOAD/PROGRESS')<{
  uploadId: string;
  uploadedBytes: number;
  totalBytes: number;
}>();

export const completeFileUpload = createAction('@FILE_UPLOAD/SUCCEEDED')<{
  uploadId: string;
}>();

export const failFileUpload = createAction('@FILE_UPLOAD/FAILED')<{
  uploadId: string;
  error: string;
}>();

export const removeFileUpload = createAction('@FILE_UPLOAD/REMOVE')<{
  uploadId: string;
}>();

export const fileUploadRemoved = createAction('@FILE_UPLOAD/REMOVED')<{
  uploadId: string;
}>();

export const setFileUploadPreview = createAction('@FILE_UPLOAD/PREVIEW_SET')<{
  uploadId: string;
  file: FileUploadSource;
  previewUri: string;
}>();

/**
 * Legacy (PHP) file uploads
 */
export const doLegacyFileUpload = createAction(
  '@FILE_UPLOAD/LEGACY_FILE_UPLOAD',
)<
  {
    eventKey: string;
    propertyId: string;
  } & (
    | {
        type: 'image-picker';
        multiSelect: boolean;
        allowVideo: boolean;
      }
    | {
        type: 'file-picker';
        multiSelect: boolean;
        allowVideo?: undefined;
      }
    | {
        type: 'camera';
        multiSelect?: false;
        allowVideo?: undefined;
      }
  )
>();

export const eventLegacyFileUploaded = createAction(
  '@FILE_UPLOAD/EVENT_LEGACY_FILE_UPLOADED',
)<{
  eventKey: string;
  propertyId: string;
  filesSyncFormat: Record<string, OfflineAssetFile>;
}>();
